module.exports = __webpack_public_path__ + "img/bg1.60e2860d.png";